import {
  SystemFieldKey,
  systemFieldDescriptions,
  systemFieldLabels,
} from "@/customFields/customFieldsDomain";
import { TMessage, TMessageParamDef } from "@/i18n/tt";

export type CompanyFieldRef =
  | { source: "SYSTEM"; field: SystemFieldKey }
  | { source: "CUSTOM"; definitionId: string };

export type CompanyFieldFormat = Extract<
  TMessageParamDef,
  { type: "country" | "date" | "datetime" | "number" | "org-no" | "percent" | "time" }
>;

export type CompanyFieldInfo = {
  type: "string" | "number" | "date";
  format?: CompanyFieldFormat;
  asOf?: boolean;
} & (
  | { source: "SYSTEM"; field: SystemFieldKey }
  | {
      source: "CUSTOM";
      definitionId: string;
      accountId: string;
      accountName: string;
      name: string;
      description?: string;
    }
);

export const companyFieldLabel = (info: CompanyFieldInfo): TMessage => {
  switch (info.source) {
    case "SYSTEM":
      return systemFieldLabels[info.field];
    case "CUSTOM":
      return { translated: info.name };
  }
};

export const companyFieldDescription = (info: CompanyFieldInfo): TMessage | undefined => {
  switch (info.source) {
    case "SYSTEM":
      return systemFieldDescriptions[info.field];
    case "CUSTOM":
      return info.description ? { translated: info.description } : undefined;
  }
};
